import React from 'react';
import {
  FluentProvider, Theme, makeStyles, mergeClasses, tokens, webLightTheme, shorthands,
} from '@fluentui/react-components';
import { Textarea } from '@fluentai/textarea';
import { Header, IHeaderProps } from './Header';
import { Loading } from './Loading';

export interface IPreparingViewProps extends IHeaderProps {
  loadingText?: string;
  theme?: Theme;
  chatInputPlaceholder?: string;
  locale?: string;
}

const usePreparingViewStyles = makeStyles({
  provider: {
    height: '100%',
  },
  wrapper: {
    height: '100%',
  },
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: tokens.colorNeutralBackground2,
    borderLeftWidth: '1px',
    borderLeftStyle: 'solid',
    borderLeftColor: tokens.colorNeutralStroke1,
  },
  loadingWrapper: {
    ...shorthands.flex(1),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  chatInputWrapper: {
    alignSelf: 'center',
    maxWidth: '652px',
    width: '100%',
    ...shorthands.padding('16px'),
  },
});

export const PreparingView: React.FC<IPreparingViewProps> = React.memo((props) => {
  const styles = usePreparingViewStyles();
  const { theme, chatInputPlaceholder } = props;
  return (
    <FluentProvider theme={theme} className={mergeClasses(styles.provider, 'ads-copilot-preparing-view')} applyStylesToPortals={false}>
      <div className={styles.root}>
        <Header {...props} />
        <div className={mergeClasses(styles.loadingWrapper, 'loading-wrapper')}>
          <Loading loadingText={props.loadingText} />
        </div>
        <div className={mergeClasses(styles.chatInputWrapper, 'chat-input-wrapper')}>
          <Textarea
            disabled
            mode="sidecar"
            placeholder={chatInputPlaceholder}
          />
        </div>
      </div>
    </FluentProvider>
  );
});

PreparingView.defaultProps = {
  theme: webLightTheme,
  loadingText: 'Preparing Copilot...',
  chatInputPlaceholder: 'Ask a question',
  locale: 'en-us',
};
